
import { PropType, defineComponent, onMounted, ref } from 'vue'

export default defineComponent({
  name: 'Tooltip',

  props: {
    selector: {
      type: Object as PropType<string | HTMLElement>,
      required: true,
    },
    tooltipValue: {
      type: String,
      required: true,
    },
  },

  setup (props) {
    const tooltipRef = ref<HTMLDivElement>()
    const isHovering = ref(false)

    onMounted(() => {
      const triggerElement = typeof props.selector === 'string' ? document.querySelector(props.selector) : props.selector

      if (triggerElement) {
        triggerElement.addEventListener('mouseenter', () => {
          isHovering.value = true
          document.addEventListener('mousemove', onMouseMove)
          if (tooltipRef.value) tooltipRef.value.style.display = 'block'
        })

        triggerElement.addEventListener('mouseleave', () => {
          isHovering.value = false
          document.removeEventListener('mousemove', onMouseMove)
          if (tooltipRef.value) tooltipRef.value.style.display = 'none'
        })
      }

      const onMouseMove = (event) => {
        if (isHovering.value && tooltipRef.value) {
          tooltipRef.value.style.left = `${ +event.pageX + 10 }px`
          tooltipRef.value.style.top = `${ +event.pageY + 10 }px`
        }
      }
    })

    return {
      tooltipRef
    }
  }
})
